<template>
  <Card
    background="background"
    color="background"
    direction="column"
  >

    <Stack direction="column">
      <TextComponent color="black">
        <b>Click "Sync" to load the user object before editing (something was broken about watching the user object, so this is my jank solution...)
        </b>
      </TextComponent>
      <TextComponent color="black">
        <b>Note: We cannot delete dictionaries here since we only transmit the difference, which
          doesn't really work with deleting things...
        </b>
      </TextComponent>

      <vue-json-editor
          v-if="Object.keys(editedUser).length > 0"
          v-model="editedUser"
          :show-btns="false"
          :expandedOnStart="true"
      ></vue-json-editor>

      <Stack>
        <Button
            v-if="Object.keys(editedUser).length > 0"
            :icon="{ left: `save` }"
            :loading="loading"
            @click="submit"
        >Save
        </Button>
        <Button
            :loading="loading"
            @click="sync"
        >Sync
        </Button>
      </Stack>
    </Stack>
  </Card>
</template>

<script>
  import Button from '@hackthe6ix/vue-ui/Button';
  import Stack from '@hackthe6ix/vue-ui/Stack';
  import TextComponent from '@hackthe6ix/vue-ui/Text';
  import swal from 'sweetalert';
  import vueJsonEditor from 'vue-json-editor';
  import VueJsonPretty from 'vue-json-pretty';
  import 'vue-json-pretty/lib/styles.css';
  import Card from '../../../../containers/Card';
  import { editObject } from '../../../../utils/api';

  const format = new Intl.DateTimeFormat(`en`, {
  minute: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  day: 'numeric',
  month: 'short',
}).format;

export default {
  name: 'AdminRaw',
  components: {
    Button,
    vueJsonEditor,
    VueJsonPretty,
    TextComponent,
    Stack,
    Card,
  },
  data() {
    return {
      loading: false,
      editedUser: {},
    };
  },
  props: {
    user: Object,
    updateUser: Function
  },
  methods: {
    sync() {
      if (Object.keys(this.editedUser).length > 0) {
        swal({
          title: 'Sync?',
          text: 'Are you sure you want to sync with the original object? You\'ll lose any changes.',
          icon: 'warning',
          buttons: true,
          dangerMode: true,
        }).then(async (confirm) => {
          if (confirm) {
            this.editedUser = this.user;
          }
        });
      } else {
        this.editedUser = this.user;
      }
    },
    /**
     * Recursively creates a dictionary with differing fields
     */
    getDiff(original, updated) {
      const isDict = (x) => typeof x === 'object' && x !== null;

      const out = {};

      let jointKeys = Object.keys(original).concat(Object.keys(updated));

      // Get unique keys
      jointKeys = jointKeys.filter((k, i) => jointKeys.indexOf(k) === i);

      let diff;

      for (const k of jointKeys) {
        if (isDict(updated[k])) {
          // Is dictionary

          diff = this.getDiff(original[k], updated[k]);

          if (diff) {
            out[k] = diff;
          }

        } else {
          // Is not a dictionary
          if (!!original !== !!updated || original[k] !== updated[k]) {
            out[k] = updated[k] === undefined ? null : updated[k];
          }
        }
      }

      return Object.keys(out).length ? out : undefined;
    },
    async submit() {
      swal({
        title: 'CONFIRM ACTION',
        text: 'Are you sure you want to update this user? Some changes may not be validated, so there is a risk of corruption or data loss.',
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then(async (confirm) => {
        if (confirm) {
          const result = await editObject(
            'user',
            {
              _id: this.user._id
            },
            this.getDiff(this.user, this.editedUser) || {}
          );

          if (result.success) {
            swal('Success', 'Your changes have been saved', 'success');
            this.updateUser(this.editedUser);
          } else {
            swal('Error', result.data, 'error');
          }


          this.loading = false;
        }
      });
    },
  },
};
</script>
